import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, FormGroup, FormControl, Row } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useEventContext } from "../../../../../context";
import { useLocaleContext } from "../../../../../context/LocaleContext";
import { updateEventModuleSettings, getEventModuleSettings } from '../../../../../../api/cp/';
import locale from "../../../../../locale";
import { availableTypesBackground } from "../../../EventSettings/models";
import { loginSettingsOptions } from "../../constants/loginAndRegistrationPage";
import * as constants from "../../../EventSettings/constants";
import ScreenInfo from "./ScreenSettings/ScreenInfo";
import ScreenEmailRequest from "./ScreenSettings/ScreenEmailRequest";
import ScreenRegistration from "./ScreenSettings/ScreenRegistration";
import ScreenRegistrationSuccess from "./ScreenSettings/ScreenRegistrationSuccess";
import ScreenRegistrationPremoderation from "./ScreenSettings/ScreenRegistrationPremoderation";
import LoginAndRegistrationPreview from "./LoginAndRegistrationPreview";
import CPSettingUploadImage from "../../../../UI/Settings/CPSettingUploadImage";
import CPSettingToggle from "../../../../UI/Settings/CPSettingToggle";
import ScreenParticipationTypeSelect from "./ScreenSettings/ScreenParticipationTypeSelect";

const LoginAndRegistrationPageSettings = () => {
    const {event} = useEventContext();
    const $locale = useLocaleContext();
    const {moduleSettings, moduleAuth} = event;
    const {guest} = event.moduleAuth;
    const [screen, setScreen] = useState('');
    const [settings, setSettings] = useState(null);
    const settingsOptions = loginSettingsOptions(
        moduleAuth.accessPreModeration,
        guest,
        moduleAuth.require,
        !!event.registrationFields.length,
        event.participationType,
        moduleAuth.email,
    );

    useEffect(fetchSettings, []);

    async function fetchSettings() {
        try {
            const response = await getEventModuleSettings(event.eventKey);
            response && setSettings(response);
        } catch (error) {
            console.error(error);
        }
    }

    const handleChangeScreen = (value) => {
        setScreen(value);
    };

    const handleUpdateEventSettings = async (data) => {
        try {
            const formData = new FormData();
            Object.keys(data).forEach(key => {
                moduleSettings[key] = data[key];
                formData.append(key, data[key]);
            });

            const reponse = await updateEventModuleSettings(event.eventKey, formData);
            setSettings(reponse);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <section>
            <Row>
                <Breadcrumb>
                    <LinkContainer to={`/event/${event.eventPassword}`}>
                        <Breadcrumb.Item>{locale('mainMenu.event')}</Breadcrumb.Item>
                    </LinkContainer>
                    <LinkContainer to={`/event/${event.eventPassword}/pages`}>
                        <Breadcrumb.Item>{locale('mainMenu.pages')}</Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>{locale('mainMenu.eventSettings.loginAndRegistration')}</Breadcrumb.Item>
                </Breadcrumb>
            </Row>

            <div style={{display: 'flex', columnGap: '40px'}}>
                <Col
                    xs={4}
                    style={{padding: 0}}
                >
                    <CPSettingUploadImage
                        eventImage={settings?.backgroundImage}
                        title="Фоновая картинка для страницы входа/регистрации"
                        settingName={constants.SETTINGS_BACKGROUND_IMAGE}
                        tooltipText={constants.SETTINGS_HINT_BACKGROUND}
                        availableTypes={availableTypesBackground}
                        onUpdate={handleUpdateEventSettings}
                    />
                    {
                        !!settings?.backgroundImage &&
                        <CPSettingToggle
                            name="changeSubstrate"
                            isChecked={settings?.changeSubstrate}
                            label="Изменить цвет подложки"
                            onChange={handleUpdateEventSettings}
                        />
                    }
                    <hr />
                    <FormGroup>
                        <FormControl
                            value={screen}
                            componentClass="select"
                            name="screen"
                            style={{maxWidth: '440px'}}
                            onChange={(e) => handleChangeScreen(e.target.value)}
                        >
                            <option value="">Выбрать область настройки</option>
                            {Object.entries(settingsOptions).map(([key, value]) => (
                                <option
                                    key={key}
                                    value={key}
                                    onChange={(e) => setScreen(e.target.value)}
                                >
                                    {value}
                                </option>
                            ))}
                        </FormControl>
                    </FormGroup>
                    {screen === constants.LOGIN_OPTION_INFO && (
                        <ScreenInfo
                            moduleSettings={moduleSettings}
                            posterImage={settings?.posterImage}
                            onUpdate={handleUpdateEventSettings}
                        />
                    )}
                    {screen === constants.LOGIN_OPTION_EMAIL_REQUEST && (
                        <ScreenEmailRequest
                            moduleSettings={moduleSettings}
                            guest={guest}
                            authRequire={moduleAuth.require}
                            hasRegistrationFields={!!event.registrationFields.length}
                            onUpdate={handleUpdateEventSettings}
                        />
                    )}
                    {screen === constants.LOGIN_OPTION_REGISTRATION && (
                        <ScreenRegistration
                            moduleSettings={moduleSettings}
                            onUpdate={handleUpdateEventSettings}
                        />
                    )}
                    {screen === constants.LOGIN_OPTION_REGISTRATION_SUCCESS && (
                        <ScreenRegistrationSuccess
                            eventName={event.name_ru}
                            moduleSettings={moduleSettings}
                            onUpdate={handleUpdateEventSettings}
                        />
                    )}
                    {(screen === constants.LOGIN_OPTION_REGISTRATION_PREMODERATION) && (
                        <ScreenRegistrationPremoderation
                            eventName={event.name_ru}
                            moduleSettings={moduleSettings}
                            onUpdate={handleUpdateEventSettings}
                        />
                    )}
                    {(screen === constants.LOGIN_OPTION_PARTICIPATION_TYPE_SELECT) && (
                        <ScreenParticipationTypeSelect
                            moduleSettings={moduleSettings}
                            onUpdate={handleUpdateEventSettings}
                        />
                    )}
                </Col>
                <Col style={{width: '100%'}}>
                    {
                        !!settings &&
                        <LoginAndRegistrationPreview
                            $locale={$locale}
                            event={event}
                            settings={settings}
                            screen={screen}
                            guest={guest}
                            onChange={handleChangeScreen}
                        />
                    }
                </Col>
            </div>
        </section>
    );
};

export default LoginAndRegistrationPageSettings;
